import { combineReducers } from 'redux'
// @ts-ignore
import { reducer as reduxFormReducer } from 'redux-form'
import themeReducer from './themeReducer'
import sidebarReducer from './sidebarReducer'
import campaignReducer from './campaignReducer'
import genresReducer from './genresReducer'
import reviewsReducer from './reviewsReducer'
import usersReducer from './usersReducer'
import playListsReducer from './playListsReducer'
import scheduleReducer from './scheduleReducer'
import campaignRatingReducer from './campaignRatingReducer'
import campaignDetailsReducer from './campaignDetailsReducer'
import transactionsReducer from './transactionsReducer'
import trackReducer from './trackReducer'
import tracksReducer from './tracksReducer'
import artistsReducer from './artistsReducer'
import auth from './auth'
import spotifyTokenReducer from './spotifyTokenReducer'
import rankReducer from './rankReducer'
import notificationsReducer from './notificationsReducer'
import sessionNotificationsReducer from './sessionNotificationsReducer'
import payoutsReducer from './payoutsReducer'
import transferwiseReducer from './transferwiseReducer'
import countriesReducer from './countriesReducer'
import analyticsReducer from './analyticsReducer'
import languagesReducer from './languagesReducer'
import titokTrackReducer from './tikTokTrackReducer'
import adminReducer from './adminReduser'
import moodsReducer from './moodsReducer'
import feedReducer from './feedReducer'
import influencerReducer from './influencerReducer'

const rootReducer = combineReducers({
  form: reduxFormReducer, // mounted under "form",
  theme: themeReducer,
  sidebar: sidebarReducer,
  campaigns: campaignReducer,
  genres: genresReducer,
  reviews: reviewsReducer,
  users: usersReducer,
  artists: artistsReducer,
  playlists: playListsReducer,
  schedule: scheduleReducer,
  campaignRating: campaignRatingReducer,
  campaignDetails: campaignDetailsReducer,
  transactions: transactionsReducer,
  spotifyTrack: trackReducer,
  spotifyTracks: tracksReducer,
  spotifyToken: spotifyTokenReducer,
  auth,
  ranks: rankReducer,
  notifications: notificationsReducer,
  sessionNotifications: sessionNotificationsReducer,
  payouts: payoutsReducer,
  transferwise: transferwiseReducer,
  countries: countriesReducer,
  analytics: analyticsReducer,
  languages: languagesReducer,
  tikTokTrack: titokTrackReducer,
  admin: adminReducer,
  moods: moodsReducer,
  feed: feedReducer,
  influencer: influencerReducer,
})

export type RootState = ReturnType<typeof rootReducer>

export default rootReducer
